import { createSlice, createAsyncThunk, createEntityAdapter, PayloadAction } from '@reduxjs/toolkit';
import axios from '../utils/axios'


const initialState = {
    data: [],
    status: 'idle',
    render_data: []
};

export const getProjects = createAsyncThunk('/projects/get', async () => {

    let res = axios.get('projects',{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }).catch((err)=>{
        console.log(err)
        // setError(err.response.data.message)
      })
      
      
      const data = await res
      console.log(data);
      return data.data.data.Projects


    
})

const projects = createSlice({
    name: 'projects',
    initialState,
    reducers: {
      // filterByCategory(state, action) {
      //   const data = state.data
      //   const filteredData = data?.filter(item => item.categories.includes(action.payload))
      //   state.render_data = filteredData
      // },
      searchData(state, {payload: {searchValue, sort, facultySort}}) {
        const data = state.data
        const filteredData = data?.filter(item => {
          if(searchValue){
            let regex = new RegExp(searchValue, 'gi')
          return item.name.match(regex)
          }
          else {
            return item
          }
        }).filter(el => {
          if(sort == 'all'){
            return el
          } else {
            return el.categories?.find(el => el._id == sort)
          }
        }).filter(el => {
          if(facultySort == 'all'){
            return el
          } else {
            return (el.user_id?.fakultet ?? "moliya") == facultySort
          }
        })
        state.render_data = filteredData
      }

    },
    extraReducers(builder) {
      builder
      .addCase(getProjects.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.status = 'failed'
      })
      .addCase(getProjects.fulfilled,(state, action) => {
        // state.status = "idle";
        state.data = action.payload;
        state.status = 'succeeded'
      })
      }
  });

export const {filterByCategory, searchData} = projects.actions
export const reducer = projects.reducer;